// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Timestamp$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as ManualPenaltyListApiModel from "../api-model/ManualPenaltyListApiModel.bs.js";

function apiModelToState(res) {
  return {
          penalty_list: List.map((function (penalty_enum) {
                  return {
                          id: penalty_enum.id,
                          name: penalty_enum.name,
                          description: penalty_enum.description
                        };
                }), res.penalty_enums),
          order_info: {
            order_id: res.order_id,
            order_time: Timestamp$Catalyst.make(res.order_time)
          },
          partner_info: {
            name: res.driver_name,
            vehicle_type: res.vehicle_type,
            msisdn: res.msisdn
          }
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(ManualPenaltyListApiModel.t_decode(json), "ManualPenaltylistEntityMapper.res"));
}

export {
  apiModelToState ,
  execute ,
  
}
/* Timestamp-Catalyst Not a pure module */
